import React, { useState, useEffect } from 'react';
import { TrendingUp, Zap, ShieldAlert } from 'lucide-react';
import { DataGrid } from '@process-advisor/process-miner/dashboard/discoveryRules/dataGrid';
import EvidenceHeader from '@process-advisor/process-miner/dashboard/shared/EvidenceHeader';
import DeterministicRulesPanel from '../../rules/DeterministicRulesPanel';


const DiscoveryRules = ({type, discoveryRules, AI, model}) => {

  const [discoveryRuleTitle, setDiscoveryRuleTitle] = useState('');

  useEffect(() => {
    if (type === 'performance') setDiscoveryRuleTitle('Performance Rules')
    if (type === 'automation') setDiscoveryRuleTitle('Automation Opportunities')
    if (type === 'compliance') setDiscoveryRuleTitle('Compliance Rules')
  }, []);

  useEffect(() => {
    if (type === 'performance') setDiscoveryRuleTitle('Performance Rules')
    if (type === 'automation') setDiscoveryRuleTitle('Automation Opportunities')
    if (type === 'compliance') setDiscoveryRuleTitle('Compliance Rules')
  }, [type]);

  const styles = {
    dashboard: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      backgroundColor: '#f8f9fa',
      padding: '16px'
    },
    controls: {
      background: 'linear-gradient(135deg, #FFFFFF 0%, #F7F9FC 100%)',
      padding: '10px 12px',
      marginBottom: '10px',
      borderRadius: '10px',
      border: '1px solid #DFE1E6',
      boxShadow: '0 1px 2px rgba(9, 30, 66, 0.06)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '8px'
    },
    insightsButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '3px 12px',
      background: 'linear-gradient(to right, #22d3ee, #a855f7)',
      color: 'white',
      fontWeight: '600',
      border: 'none',
      borderRadius: '9999px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      outline: 'none'
    },
    controlsLeft: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(9, 45, 66, 0.54)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '24px'
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(9, 45, 66, 0.25)',
      width: '100%',
      maxWidth: '700px',
      maxHeight: '80vh'
    },
    modalHeader: {
      padding: '24px 32px 16px',
      borderBottom: '1px solid #f4f5f7',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    modalTitle: {
      fontSize: '24px',
      fontWeight: '600',
      color: '#172b4d',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    closeButton: {
      padding: '8px',
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      borderRadius: '6px',
      transition: 'background-color 0.2s'
    }
  };

  if (type === 'performance' || type === 'compliance') {
    return <DeterministicRulesPanel category={type} model={model || {}} />;
  }

  return (
    <div style={styles.dashboard}>
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(9, 30, 66, 0.54);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .modal {
          background: white;
          border-radius: 3px;
          width: 90%;
          max-width: 440px;
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
        }
        .modal-header {
          padding: 20px 24px;
          border-bottom: 2px solid #dfe1e6;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .modal-title {
          font-size: 20px;
          font-weight: 500;
          color: #172b4d;
        }
        .modal-close {
          background: none;
          border: none;
          cursor: pointer;
          padding: 4px;
          color: #5e6c84;
        }
        .modal-close:hover {
          color: #172b4d;
        }
        .modal-body {
          padding: 24px;
        }
        .modal-description {
          font-size: 14px;
          color: #5e6c84;
          margin-bottom: 20px;
        }
        .export-option {
          border: 2px solid #dfe1e6;
          border-radius: 3px;
          padding: 16px;
          margin-bottom: 12px;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: flex-start;
        }
        .export-option:hover {
          border-color: #0052cc;
          background: #f4f5f7;
        }
        .export-icon {
          width: 40px;
          height: 40px;
          margin-right: 12px;
          flex-shrink: 0;
        }
        .export-content {
          flex: 1;
        }
        .export-option-title {
          font-size: 14px;
          font-weight: 600;
          color: #172b4d;
          margin-bottom: 4px;
        }
        .export-option-description {
          font-size: 12px;
          color: #5e6c84;
        }
        .modal-footer {
          padding: 16px 24px;
          border-top: 2px solid #dfe1e6;
          display: flex;
          justify-content: flex-end;
        }
        .modal-cancel-button {
          background: none;
          border: none;
          color: #5e6c84;
          padding: 8px 12px;
          border-radius: 3px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }
        .modal-cancel-button:hover {
          background: #ebecf0;
        }
        .section {
          margin-bottom: 12px;
          border: 1px solid #dfe1e6;
          border-radius: 3px;
          overflow: hidden;
        }
        .section-header {
          display: flex;
          align-items: center;
          padding: 16px 20px;
          background: #fafbfc;
          cursor: pointer;
          transition: background 0.2s;
        }
        .section-header:hover {
          background: #ebecf0;
        }
        .section-icon {
          width: 24px;
          height: 24px;
          margin-right: 12px;
          flex-shrink: 0;
        }
        .section-title {
          flex: 1;
          font-size: 16px;
          font-weight: 600;
          color: #172b4d;
        }
        .section-count {
          margin-left: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #5e6c84;
        }
        .section-toggle {
          width: 20px;
          height: 20px;
          transition: transform 0.3s;
        }
        .section-toggle.expanded {
          transform: rotate(180deg);
        }
        .section-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
          background: white;
        }
        .section-content.expanded {
          max-height: 600px;
          overflow-y: auto;
        }
        .section-body {
          padding: 12px 20px;
        }
      `}</style>


      <EvidenceHeader
        icon={type === 'performance' ? <TrendingUp size={18} /> : type === 'automation' ? <Zap size={18} /> : <ShieldAlert size={18} />}
        title={discoveryRuleTitle}
        subtitle={type === 'performance' ? 'Identify evidence-backed workflow bottlenecks and delay patterns.' : type === 'automation' ? 'Review repeatable work patterns suitable for automation.' : 'Review process compliance gaps and workflow control issues.'}
      />
    
      <DataGrid rows={discoveryRules} type={type} AI={AI}/>
    
    </div>
  );
};

export default DiscoveryRules;